import { render, staticRenderFns } from "./TableHandler.vue?vue&type=template&id=62d1dfaf&scoped=true&"
import script from "./TableHandler.vue?vue&type=script&lang=js&"
export * from "./TableHandler.vue?vue&type=script&lang=js&"
import style0 from "./TableHandler.vue?vue&type=style&index=0&id=62d1dfaf&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62d1dfaf",
  null
  
)

export default component.exports